'use es6';

import PropTypes from 'prop-types';
import { FLINT } from 'HubStyleTokens/colors';
import { getRealPath } from '../filterQueryFormat/logic/LogicGroup';
import FilterType from './propTypes/FilterType';
import { List } from 'immutable';
import { isAssociationBranch } from './strategies/ObjectSegStrategyUtils';
import FilterFamilyHeadingWithAssociations from './FilterFamilyHeadingWithAssociations';
import { COMPANY_TYPE_ID, CONTACT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { COMPANY, CONTACT } from 'customer-data-objects/property/ExternalOptionTypes';
import { jsx as _jsx } from "react/jsx-runtime";
const FilterFamilyHeading = props => {
  const {
    baseFilterFamily,
    conditionPath,
    filterFamily,
    getFilterFamilyGroupHeading,
    getFilterFamilyObjectName,
    getObjectAssociationOptions,
    isAssociationSelectEnabled,
    isReadOnly,
    onBranchAssociationChange,
    value,
    onUserAction
  } = props;
  const isObjectAssociationBranch = isAssociationBranch(value.getIn(getRealPath(conditionPath)));
  const showAssociationSelect = isObjectAssociationBranch && isAssociationSelectEnabled;
  if (showAssociationSelect) {
    return /*#__PURE__*/_jsx(FilterFamilyHeadingWithAssociations, {
      baseFilterFamily: baseFilterFamily,
      conditionPath: conditionPath,
      filterFamily: filterFamily,
      getFilterFamilyObjectName: getFilterFamilyObjectName,
      getObjectAssociationOptions: getObjectAssociationOptions,
      isReadOnly: isReadOnly,
      onBranchAssociationChange: onBranchAssociationChange,
      onUserAction: onUserAction,
      value: value
    });
  }
  let filterFamilyHeading = getFilterFamilyGroupHeading(filterFamily);

  // Classic contact list filters do not support flexible associations
  // at the same time they ONLY look in "Primary" associated companies
  // if associated company filters are used, therefore change copy
  // from "At least one associated company has" to "Primary associated company has"
  // example of this is contacts workflows since they aren't using ILS yet
  if ((baseFilterFamily === CONTACT_TYPE_ID || baseFilterFamily === CONTACT) && (filterFamily === COMPANY_TYPE_ID || filterFamily === COMPANY)) {
    filterFamilyHeading = /*#__PURE__*/_jsx(FormattedMessage, {
      message: "customerDataFilters.FilterFamilyGroupHeadingTranslator.CONTACT_TO_COMPANY_PRIMARY"
    });
  }
  if (filterFamilyHeading) {
    return /*#__PURE__*/_jsx("span", {
      className: "display-block p-left-4 p-right-3",
      style: {
        color: FLINT
      },
      children: filterFamilyHeading
    });
  }
  return null;
};
FilterFamilyHeading.propTypes = {
  baseFilterFamily: PropTypes.string.isRequired,
  conditionPath: PropTypes.instanceOf(List),
  filterFamily: PropTypes.string.isRequired,
  getFilterFamilyGroupHeading: PropTypes.func.isRequired,
  getFilterFamilyObjectName: PropTypes.func.isRequired,
  getObjectAssociationOptions: PropTypes.func,
  isAssociationSelectEnabled: PropTypes.bool,
  isReadOnly: PropTypes.bool.isRequired,
  onBranchAssociationChange: PropTypes.func,
  onUserAction: PropTypes.func,
  value: FilterType.isRequired
};

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
FilterFamilyHeading.defaultProps = {
  isReadOnly: false
};
export default FilterFamilyHeading;